var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttributesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20244 3.4789C9.04646 3.18427 8.7404 3 8.40703 3C8.07366 3 7.7676 3.18427 7.61162 3.4789L1.13211 15.718C0.899548 16.1573 1.06713 16.7019 1.50642 16.9345C1.94572 17.167 2.49037 16.9995 2.72293 16.5602L4.37513 13.4393H12.4389L14.0911 16.5602C14.3237 16.9995 14.8683 17.167 15.3076 16.9345C15.7469 16.7019 15.9145 16.1573 15.6819 15.718L9.20244 3.4789ZM11.486 11.6393L8.40703 5.82354L5.32807 11.6393H11.486Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9262 10.4604C17.9553 10.4604 16.1464 11.8824 16.1464 13.8802C16.1464 15.878 17.9553 17.3 19.9262 17.3C20.7067 17.3 21.4619 17.077 22.0893 16.6835C22.2537 16.8995 22.5136 17.039 22.806 17.039C23.3031 17.039 23.706 16.6361 23.706 16.139V10.6405C23.706 8.64085 21.9023 7.22307 19.9313 7.22066C18.8931 7.21031 17.8921 7.60722 17.1431 8.32638C16.7845 8.67063 16.7729 9.24036 17.1172 9.59891C17.4614 9.95746 18.0312 9.96905 18.3897 9.6248C18.7997 9.23117 19.3478 9.01421 19.9161 9.0206L19.9262 9.02065C21.139 9.02065 21.906 9.85199 21.906 10.6405V10.9688C21.3173 10.6428 20.6321 10.4604 19.9262 10.4604ZM17.9464 13.8802C17.9464 13.0947 18.7162 12.2604 19.9262 12.2604C21.1362 12.2604 21.906 13.0947 21.906 13.8802C21.906 14.6657 21.1362 15.5 19.9262 15.5C18.7162 15.5 17.9464 14.6657 17.9464 13.8802Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5872 20.9016H2.14722C1.7156 20.9016 1.36719 20.4984 1.36719 20.0016C1.36719 19.5048 1.7156 19.1016 2.14722 19.1016H22.5872C23.0177 19.1016 23.3672 19.5048 23.3672 20.0016C23.3672 20.4984 23.0177 20.9016 22.5872 20.9016Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributesActive);
export default __webpack_public_path__ + "static/media/attributes-active.417c6879db0c10cfa552c00263541900.svg";
export { ForwardRef as ReactComponent };